export function safeReturnTo(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value)) return null;
  const url = new URL(value, window.location.origin);
  if (url.origin !== window.location.origin || url.pathname === '/login') return null;
  return url.pathname + url.search + url.hash;
}
